import axios from "axios";
import React, { createContext, useState } from "react";
import { Navigate } from "react-router-dom";
import apiPath from "../constants/apiPath";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // ✅ Load immediately from localStorage
  const storedUser = JSON.parse(localStorage.getItem("admin_userProfile"));
  const storedToken = localStorage.getItem("admin_token");

  const [isLoggedIn, setIsLoggedIn] = useState(!!storedToken);
  const [session, setSession] = useState({ token: storedToken });
  const [userProfile, setUserProfile] = useState(storedUser || null);
  const [userPermission, setUserPermission] = useState(
    storedUser?.roleId?.permission || [],
  );

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = () => {
    // Best-effort presence marker — there's no server-side JWT revocation,
    // so this is what flips the header status to Offline. Fire before
    // clearing the token (the request needs it) and don't block on it.
    const token = localStorage.getItem("admin_token");
    if (token) {
      axios
        .post(apiPath.baseURL + apiPath.logout, {}, { headers: { Authorization: `Bearer ${token}` } })
        .catch(() => {});
    }
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_userProfile");
    window.location.href = `${window.location.origin}/login`;
    return <Navigate to="/login" />;
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        userPermission,
        setUserPermission,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
